<template>
  <v-container
    fluid
    class="ma-0 pa-0"
  >
    <v-row class="mx-0 px-0">
      <v-col>
        <h5 class="text-h5">
          {{ $t("report.visualizationView.reportTitle") }}
        </h5>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="mx-0 px-0">
      <v-col class="md-3 mx-0 px-0">
        <v-simple-table>
          <tbody>
            <tr>
              <td class="opacity-6 pl-4">{{ $t("report.serviceTable.id") }}</td>
              <td class="pr-4">{{ reportWSI.id }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>   
      <v-col class="md-3 mx-0 px-0">
        <v-simple-table>
          <tbody>
            <tr>
              <td class="opacity-6 pl-4">{{ $t("report.serviceTable.biopsyID") }}</td>
              <td class="pr-4">{{ reportWSI.biopsy_id }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
      <!-- <v-col>
        <div class="text-subtitle-1">
          <span> ID: {{ reportWSI.id }} </span>
        </div>
      </v-col>
      <v-col>
        <div class="text-subtitle-1">
          <span> {{ $t("report.serviceTable.biopsyID") }}: {{ reportWSI.biopsy_id }} </span>
        </div>
      </v-col> -->
    </v-row>
    <v-divider class="mb-4"></v-divider>
    <v-row class="mx-0 px-0">
      <v-col class="mx-0 px-0">
        <v-data-table
          :v-if="diagnosisByName !== undefined"
          :headers="probHeaders"
          :items="probItems"
          item-key="name"
          sort-by="prob"
          :sort-desc="true"
          hide-default-footer
          flat
          dense
        >
          <template v-slot:item="{ item }">
            <tr>
              <td :style="{ backgroundColor: item.color + ' !important' }"></td>
              <td class="padding-left">
                {{ $t('report.' + item.name) }}
              </td>
              <td class="text-center">{{ item.prob.toFixed(2) }} %</td>
              <td class="text-center">
                <span v-if="item.name !== 'normal'">{{ item.sus_area.toFixed(2) }} mm<sup>2</sup></span>
                <span v-else> - </span>
              </td>
              <td class="text-center">
                <span v-if="item.name !== 'normal'">{{ item.sus_percentage.toFixed(2) }} %</span>
                <span v-else> - </span>
              </td>
              <td class="text-center">
                <span v-if="item.name !== 'normal'">{{ item.sus_count }}</span>
                <span v-else> - </span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-col>
      <h5 class="text-h5">
        {{ $t("report.visualizationView.reportSuspiciousAreaTitle") }}
      </h5>
    </v-col>
    <v-row class="mx-0 px-0">
      <v-col class="mx-0 px-0">
        <v-data-table
          :headers="headers"
          :items="areas"
          item-key="id"
          sort-by="label"
          :sort-desc="false"
          :items-per-page="10"
          :item-class="rowClass"
          dense
          :footer-props="{
            'items-per-page-options': [10]
          }"
        >
          <template v-slot:item="{ item }">
            <tr @click="centerArea(item)">
              <td :style="{ backgroundColor: item.color + ' !important' }"></td>
              <td class="padding-left">
                {{ item.label }}
              </td>
              <td>{{ $t("report." + item.class) }}</td>
              <td>{{ item.area.toFixed(2) }} mm<sup>2</sup></td>
              <td>{{ item.percentage.toFixed(2) }} %</td>
              <td>
                <div>
                  <v-tooltip class="text-truncate" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        @click="selectArea(item)"
                      >
                        mdi-cursor-default-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("report.diagnosisTable.selectAreaTooltip") }}
                    </span>
                  </v-tooltip>
                  <!-- NEEDS FIXING -->
                  <!-- <v-tooltip class="text-truncate" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        @click="deleteArea(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("report.diagnosisTable.deleteAreaTooltip") }}
                    </span>
                  </v-tooltip> -->
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <!-- <div class="d-flex"> -->
    <div>
      <v-col class="px-0 mx-0">
        <v-tooltip right>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              block
              tile
              class="info"
              elevation="0"
              v-on="on"
              v-bind="attr"
              @click="saveReport"
            >
              {{ $t("report.saveViewReport") }}
            </v-btn>
          </template>
          <span>
              {{ $t("report.saveViewReportTooltip") }}
          </span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              block
              tile
              :disabled="disabledNext"
              elevation="0"
              v-on="on"
              v-bind="attr"
              @click="$emit('next-report')"
            >
              {{ $t("report.visualizationView.nextButton") }}
              <v-icon
                right
                light
              >
                mdi-arrow-right-thick
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ $t("report.visualizationView.nextButtonTooltip") }}
          </span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              block
              tile
              :disabled="disabledPrevious"
              elevation="0"
              v-on="on"
              v-bind="attr"
              @click="$emit('previous-report')"
            >
              <v-icon
                left
                light
              >
                mdi-arrow-left-thick
              </v-icon>
              {{ $t("report.visualizationView.previousButton") }}
            </v-btn>
          </template>
          <span>
            {{ $t("report.visualizationView.previousButtonTooltip") }}
          </span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              block
              tile
              class="warning"
              elevation="0"
              v-on="on"
              v-bind="attr"
              @click="$emit('go-back')"
            >
              {{ $t("report.visualizationView.goBack") }}
            </v-btn>
          </template>
          <span>
              {{ $t("report.visualizationView.goBackTooltip") }}
          </span>
        </v-tooltip>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  // props: {
  //   reportTileGrid: Object,
  // },
  data() {
    return {
      areas: [],
      probItems: [],
      areaByDiagnosis: {},
      disabledPrevious: false,
      disabledNext: false,
    };
  },
  computed: {
    ...mapState({
      reportWSI: state => state.service.currentReportWSI,
      reportTileGrid: state => state.service.currentReportTileGrid,
      reportDiagnosis: state => state.service.currentReportDiagnosis,
      diagnosisByName: state => state.diagnosis.byName
    }),
    inGroups() {
      // show in groups if more than 1 class is present
      const classes = [...new Set(this.areas.map(item => item.class))];
      return classes.length > 1;
    },
    headers() {
      return [
        {
          text: "",
          align: "start",
          value: "",
          groupable: false,
          width: "20px",
          sortable: false,
          class: "th-no-padding" 
        },
        { text: this.$t("report.diagnosisTable.areaID"), value: "label", groupable: false, class: "padding-left" },
        { text: this.$t("report.diagnosisTable.class"), value: "class" , class: "th-no-padding" },
        { text: this.$t("report.diagnosisTable.areaSize"), value: "area", groupable: false, class: "th-no-padding" },
        {
          text: this.$t("report.diagnosisTable.areaPercentage"),
          value: "percentage",
          groupable: false, class: "th-no-padding" 
        },
        { text: "", value: "actions", groupable: false, sortable: false, width: "64px", class: "th-no-padding" }
      ];
    },
    probHeaders() {
      return [
        {
          text: "",
          align: "start",
          value: "",
          groupable: false,
          width: "20px",
          sortable: false,
          class: "th-no-padding"
        },
        { text: this.$t("report.diagnosisTable.class"), value: "name"},
        { text: this.$t("report.diagnosisTable.confidenceLevel"), value: "prob"},
        { text: this.$t("report.diagnosisTable.areaSize"), value: "sus_area"},
        { text: this.$t("report.diagnosisTable.areaPercentage"), value: "sus_percentage"},
        { text: this.$t("report.diagnosisTable.areaCount"), value: "sus_count"},
      ];
    },
  },
  watch: {
    reportTileGrid: {
      deep: true,
      immediate: true,
      handler() {
        this.setAreas();
      }
    },
    diagnosisByName: {
      deep: true,
      // immediate: true,
      handler() {
        this.setDiagnosis();
      }
    }
  },
  methods: {
    async saveReport() {
      this.$emit("save");
    },
    centerArea(area) {
      this.$emit("center-area", area);
    },
    selectArea(area) {
      this.$emit("select-area", area);
    },
    deleteArea(area) {
      if (
        confirm(this.$t("report.diagnosisTable.deleteAreaMessage"))
      ) {
        this.$emit("delete-area", area);
      }
    },
    rowClass(item) {
      const style = {
        "background-color": item.color + " !important"
      };
      return style;
    },
    setDiagnosis() {
      this.probItems = [];
      const diagnosis_dict = {};
      Object.values(this.diagnosisByName).forEach(diagnosis => {
        diagnosis_dict[diagnosis.id] = diagnosis.name;
      });
      this.reportDiagnosis.forEach(prob => {
        const count = this.diagnosisByName[diagnosis_dict[prob.label]].count;
        const ratio = this.diagnosisByName[diagnosis_dict[prob.label]].ratio;
        const color = this.diagnosisByName[diagnosis_dict[prob.label]].color;
        const area = this.areaByDiagnosis[diagnosis_dict[prob.label]]
          ? this.areaByDiagnosis[diagnosis_dict[prob.label]]
          : 0;
        this.probItems.push({
          name: diagnosis_dict[prob.label],
          prob: prob.confidence_level * 100,
          color: color,
          sus_count: count,
          sus_percentage: ratio,
          sus_area: area,
        });
      });
    },
    setAreas() {
      this.areas = [];
      this.areaByDiagnosis = {};
      Object.keys(this.reportTileGrid.tilegrid_json["areas"]).forEach(areas => {
        areas = this.reportTileGrid.tilegrid_json["areas"][areas];
        Object.keys(areas).forEach(area => {
          area = areas[area];
          let classType = area["class"].toLowerCase();
          if (classType === "otro") classType = "other"; //FIX LOCALIZATION FROM CDSS
          const classDef = this.diagnosisByName[classType];
          const size = area["area"];
          const ratio = area["rate"];
          const suspicious = area["suspicious"];
          const id = area["id"];
          const label = area["label"] ? area["label"] : id;
          if (suspicious) {
            this.areas.push({
              id: id,
              class: classDef.name,
              area: size,
              percentage: ratio,
              suspicious: suspicious,
              validated: false,
              color: classDef.color,
              label: label
            });
            this.areaByDiagnosis[classDef.name] =
              (this.areaByDiagnosis[classDef.name] || 0) + size;
          }
        });
      });
    }
  }
};
</script>
<style scoped>
>>>.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0px;
}
>>>.th-no-padding {
  padding: 0px !important;
}
>>>.padding-left {
  padding: 0px !important;
  padding-left: 5px !important;
}
.opacity-6 {
  color: rgba(0, 0, 0, 0.6);
}
</style>
